import { render, staticRenderFns } from "./TipoVez.vue?vue&type=template&id=f43253c2"
import script from "./TipoVez.vue?vue&type=script&lang=js"
export * from "./TipoVez.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports